import {
  Component,
  Input,
  OnInit,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SurchargeTypeRepository } from "../../../surcharge-type/surcharge-type.repository";
import { Bind } from "primeng/bind";
import { AutoComplete } from "primeng/autocomplete";
import { FormsModule } from "@angular/forms";

export interface SurchargeTypeChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-surcharge-type-autocomplete",
  templateUrl: "./surcharge-type-autocomplete.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, AutoComplete, FormsModule],
})
export class SurchargeTypeAutocompleteComponent implements OnInit {
  private surchargeTypeRepository = inject(SurchargeTypeRepository);

  public readonly surchargeTypeChange = output<string>();
  @Input() public surchargeType: string;
  public readonly disabled = input(false);

  public subscription = new Subscription();
  public surchargeTypeList: string[] = [];
  public filteredSurchargeTypes: string[] = [];

  ngOnInit() {
    this.buildSurchargeTypeList();
  }

  public onSurchargeTypeChange(event: string) {
    this.surchargeType = event;
    this.surchargeTypeChange.emit(event);
  }

  private buildSurchargeTypeList(): void {
    this.subscription.add(
      this.surchargeTypeRepository.list().subscribe((typeList) => {
        typeList.map((surchargeType) => {
          this.surchargeTypeList.push(surchargeType.getName());
        });
      }),
    );
  }

  filterSurchargeType(event) {
    const filtered: any[] = [];
    const query = event.query;

    for (let i = 0; i < this.surchargeTypeList.length; i++) {
      const surchargeType = this.surchargeTypeList[i];
      if (surchargeType.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(surchargeType);
      }
    }

    this.filteredSurchargeTypes = filtered;
  }
}
